import { NewsModule } from './../news/news.module';
import { NgModule } from '@angular/core';
import { SharedModule } from './../shared/shared.module';
import { DashboardRoutingModule, routedComponents } from './dashboard-routing.module';
import { BannerComponent } from './../core/banner/banner.component';
import {
  CalendarModule,
  CheckboxModule,
  DialogModule,
  InputTextModule,
  ScheduleModule,

} from 'primeng/primeng';
import { BannerSidebarComponent } from './../core/banner/banner-sidebar/banner-sidebar.component';
import { EventCalendarHomepageComponent } from 'app/events/event-calendar-homepage/event-calendar-homepage.component';
import { EventListComponent } from 'app/events/event-list/event-list.component';
import { EventComponent } from 'app/events/event/event.component';
import { EventService } from 'app/events/shared/event.service';

@NgModule({
  imports: [DashboardRoutingModule, SharedModule, NewsModule, DialogModule, CalendarModule, ScheduleModule, CheckboxModule, InputTextModule ],
  exports: [],
  declarations: [routedComponents, BannerComponent, BannerSidebarComponent, EventCalendarHomepageComponent, EventListComponent, EventComponent],
  providers: [EventService],
})

export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.module.ts